import { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import styles from "./selectFieldComponent.module.scss";

const SelectFieldComponent = ({
  optionsList,
  firstOption,
  onSelectChange,
  classes,
  value,
  externalLoading,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const displayLoading = isLoading || externalLoading;

  useEffect(() => {
    setIsLoading(false);
  }, [firstOption]);

  const handleSelectChange = async (event) => {
    // setIsLoading(true);
    const selectedValue = event.target.value;
    onSelectChange(selectedValue);
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    // setIsLoading(false);
  };

  if (displayLoading) {
    return (
      <div className="d-flex justify-content-center w-100">
        <ClipLoader color="#fff" size="22px" />
      </div>
    );
  }

  return (
    <div className="w-100">
      {displayLoading && (
        <div className="d-flex justify-content-center w-100">
          <ClipLoader color="#fff" size="22px" />
        </div>
      )}
      <select
        className={`${classes} ${styles.select}`}
        onChange={handleSelectChange}
        value={value}
      >
        <option value="" hidden className="text-black">
          {firstOption}
        </option>
        {optionsList.map((dt, index) => (
          // console.log(dt)
          <option value={dt?.value} key={index}>
            {dt?.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectFieldComponent;
